import React from 'react';

export default function FittingRooms() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2223 15.9996C30.2223 23.8543 23.8548 30.2218 16.0001 30.2218C8.14534 30.2218 1.77783 23.8543 1.77783 15.9996C1.77783 8.14485 8.14534 1.77734 16.0001 1.77734C23.8548 1.77734 30.2223 8.14485 30.2223 15.9996Z"
        fill="white"
        stroke="black"
        strokeMiterlimit="10"
      />
      <path
        d="M15.8737 14.2525L15.9219 12.6579C16.9342 12.6579 17.8018 11.8364 17.8018 10.7733C17.8018 9.75849 16.9824 8.88867 15.9219 8.88867C14.8615 8.88867 14.0421 9.71016 14.0421 10.7733M15.8737 14.2525C15.8737 14.2525 21.2849 16.6494 22.7585 17.4305C24.2322 18.2116 23.6771 20.4442 22.0092 20.4442C20.3414 20.4442 9.41247 20.4442 9.41247 20.4442C9.41247 20.4442 9.41247 20.4442 9.41247 20.4442C7.72594 20.4442 7.18702 18.1721 8.6939 17.4147L15.8737 14.2525Z"
        stroke="black"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
